<template>
  <div class="wrcOutStockList">
    <div class="stockInfo">
      <div class="item"><label>仓库名称：</label><span>{{wareName}}</span></div>
      <currtime :isShowInfo="true"></currtime>
    </div>
    <div class="table">
      <div class="tab_tit flex">
        <div class="item">产品编号</div>
        <div class="item">产品名称</div>
        <div class="item">供应商</div>
        <div class="item">规格</div>
        <div class="item">RFID标签</div>
      </div>
      <div class="tabList">
        <el-collapse accordion>
          <el-collapse-item v-for="(item,index) in stockData" :key="index" :class="{'feifa':item.type}">
            <template slot="title">
              <span><template v-if="!item.type">品类：</template>{{item.category}}</span><span>共{{item.data.length}}{{item.unit}}</span>
            </template>
            <div :class="{'warning':item.type,item}" v-for="(item2,index2) in item.data" :key="index2">
              <div class="flex">
                <div class="itemLi">{{item2.sn}}</div>
                <div class="itemLi">{{item2.product_name}}</div>
                <div class="itemLi">{{item2.supplier}}</div>
                <div class="itemLi">{{item2.spec}}</div>
                <div class="itemLi">{{item2.rfid}}</div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <!-- <div v-for="(item,index) in stockData" :key="index" class="item">
          <div class="flex">
            <div class="itemLi">{{item.sn}}</div>
            <div class="itemLi">{{item.category}}</div>
            <div class="itemLi">{{item.product_name}}</div>
            <div class="itemLi">{{item.supplier}}</div>
            <div class="itemLi">{{item.unit}}</div>
            <div class="itemLi">{{item.rfid}}</div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="configBtn flex">
      <div class="tips"></div>
      <div>
      <el-button class="backUp" @click="backUp">返回</el-button>
      <el-button @click="submitWare" :class="{'is-disabled':errorEnd}">确认出库</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="tipDio" class="tipDio" width="40%" :show-close="showClose" :close-on-click-modal="showClose">
      <div class="contDio">
        <h2>出库完成</h2>
        <div class="tips">{{time}}s后将退出登录</div>
      </div>
    </el-dialog>
    <template v-if="isSendFun">
    <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" :topic2="topic2" :msg2="msg2" :isSend="isSend" ref="mqttws" @getMessage="getMessage"></mqttws>
    </template>
  </div>
</template>

<script>
import currtime from '../../../assets/currTime'
import mqttws from '../../../assets/mqttws'
import { loginApi,borrowApi, wareApi } from '../../../../static/js/api.js'
import { localUserInfo,text2Audio } from '../../../../static/js/utils/utility.js'
import {checkData} from '../../../../static/js/utils/util.js'
import * as config from '../../../../static/js/config.js';
import again3Mp3 from '../../../../static/mp3/again3.mp3'
import outWareEndMp3 from '../../../../static/mp3/outWareEnd.mp3'
export default {
  name: 'wrcOutStockList',
  data () {
    return {
      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      topic2 :'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg2 :'a5551505160101010000000101d70200020100de',
      isConnect:true,//是否默认订阅
      isSend:true,

      wareName:'',//仓库名

      stockData:[],
      allData:[],
      time:5,
      timeStatus:'',

      tipDio:false,//提示弹窗
      showClose:false,//是否显示关闭按钮
      // clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      // candelete: {}, // 滑动的item

      accessControl:'',//门禁id

      overtime:60,//超时
      overtimeStatus:'',//超时状态

      isSendFun:false,

      isErrorTips:false,
      errorEnd:false,
    }
  },
  mounted(){
    this.isSendFun = true
  },
  components:{
    mqttws,
    currtime
  },
  created() {
    this.getWareName()
    this.accessControl = JSON.parse(localStorage.getItem('configStorage')).accessControl
    this.overTime(this.overtime)
  },
  methods:{
    //返回
    backUp(){
      var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
      var msg = 'a5551505160101010000000101d703000101dc'
      this.$refs.mqttws.send(topic,msg)
      clearTimeout(this.overtimeStatus)
      // this.$refs.mqttws.disconnect()
      localUserInfo.removeItem()
      this.$router.push({
        path:'/unmanned/wrcIndex',
      })
    },
    //获取仓库名称
    async getWareName(){
      var that = this
      var device_no_id=config.deviceId

      var data = {
        'device_no_id':device_no_id.split(','),
      }
      var res = await wareApi.showProduct(data)
      if (res.meta.code == 200) {
        if(res.body!=''){
          that.wareName = res.body[0].storage
        }
      } else {
        that.$message.error(res.meta.message)
      }
    },
    //倒计时
    getSecond(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        that.loginOut()
      } else {
        this.time=wait
        wait--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(wait);
        },1000);
      }
    },
    loginOut(){
      this.tipDio=false
      clearTimeout(this.timeStatus)
      // this.$refs.mqttws.disconnect()
      localUserInfo.removeItem()
      this.$router.push({
        path:'/unmanned/wrcIndex',
      })
    },
    //收取mqtt信息
    getMessage(data){
      console.log('data',data)
      var that = this;
      if(data){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        var type = str.substring(26,30)
        if(type == 'd702'){
          that.overtime=60
          var lastTwo = str.substring(str.length-2,str.length)
          var id = str.substring(str.length-4,str.length)
          if(lastTwo == 55 && num == bbc){
            var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
          }else{
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d70200020100de'
            setTimeout(function(){
              that.$refs.mqttws.send(topic,msg)
            },2000)
          }
        }else if(type == 'df0c'){
          that.overtime=60
          var data2 = data.substring(2,data.length)
          if(num == bbc){
            //调用后台接口
            // console.log(data2)
            that.getProduct(data2)
          }else{
            that.$message.error('请重新扫描物品！')
            // text2Audio('请重新扫描物品')
            var url = again3Mp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
          }
        }else if(type == 'd703'){
          var lastTwo2 = str.substring(str.length-2,str.length)
          if(lastTwo2 == 55){
            if(that.accessControl != ''){
              //下发打开门禁指令
              var topic = '/'+ config.serverPort +'/down/'+ that.accessControl +'/control/protocol'
              var msg = 'a5551505160101010000000101d307000301138845'
              that.$refs.mqttws.send(topic,msg)
            }
            that.$refs.mqttws.disconnect()
            that.outWare()
            // var topic2 = '/'+ config.serverPort +'/down/'+ that.accessControl +'/control/protocol/response'
            // that.$refs.mqttws.onConnect(topic2)
            
          }
        }
        // else if(type == 'd307'){
        //   var lastTwo2 = str.substring(str.length-2,str.length)
        //   if(lastTwo2 == 55){
        //     that.tipDio=true
        //     that.getSecond(that.time)
        //   }
        // }
      }
    },
    //发送停止盘点指令
    submitWare(){
      var that = this;
      console.log(this.errorEnd)
      if(this.errorEnd == true){
        this.$message.error('检测到非法物品，请拿走非法物品后再进行出库')
        return
      }
      var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
      var msg = 'a5551505160101010000000101d703000101dc'
      that.$refs.mqttws.send(topic,msg)
      
    },
    //提交出库
    async outWare(){
      var that = this;
      var idList =[]
      if(this.allData!=''){
        for(var i in that.allData){
          idList.push(that.allData[i].id.toString())
        }
        var dataObj = {
          'device_no_id': config.deviceId,
          'id':idList,
          'user_id':localUserInfo.getItem().user_id
        }
        var res = await wareApi.outStorage(dataObj)
        if(res.meta.code == '200'){
          // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
          // var msg = 'a5551505160101010000000101d703000101dc'
          // that.$refs.mqttws.send(topic,msg)
          // that.tipDio=true
          // that.getSecond(that.time)
          clearTimeout(that.overtimeStatus)
          that.tipDio=true
          // text2Audio('出库完成')
          var url = outWareEndMp3
          var audio = new Audio(url);
          audio.src = url;
          audio.play();
          that.getSecond(that.time)
        }else{
          that.$refs.mqttws.onConnection()
          that.$message.error(res.meta.message)
        }
      }else{
        that.$refs.mqttws.onConnection()
        that.$message.error('请先扫描物品！')
      }
    },
    //通过传rfid命令获取产品
    async getProduct(dataStr){
      var that = this;
      var dataObj = {
        'device_no_id': config.deviceId,
        'data': dataStr,
        'type': 'out',
      }
      var res = await wareApi.getProductRfid(dataObj);
      if(res.meta.code == '200'){
        if(res.body!=''){
          that.stockData = []
          if(res.body.errorRfid!=''){
            if(that.isErrorTips == false){
              that.$message.error('检测到非法物品，请拿走非法物品后再进行扫描');
            }
            that.isErrorTips = true
            that.errorEnd = true
            var result2 = res.body.errorRfid
            //按品类分组
            var map2 = {},
            dest2 = [];
            for(var i = 0; i < result2.length; i++){
              if(result2[i].sn == ''){
                result2[i].sn = '/'
              }
              if(result2[i].product_name == ''){
                result2[i].product_name = '/'
              }
              if(result2[i].supplier == ''){
                result2[i].supplier = '/'
              }
              if(result2[i].spec == ''){
                result2[i].spec = '/'
              }
              var ai2 = result2[i];
              if(!map2[ai2.category_id]){
                dest2.push({
                  category_id: ai2.category_id,
                  category: ai2.category,
                  unit:ai2.unit,
                  type:'1',
                  data: [ai2]
                });
                map2[ai2.category_id] = ai2;
              }else{
                for(var j = 0; j < dest2.length; j++){
                  var dj2 = dest2[j];
                  if(dj2.category_id == ai2.category_id){
                    dj2.data.push(ai2);
                    break;
                  }
                }
              }
            }
            that.stockData.push.apply(that.stockData,dest2)
          }else{
            that.errorEnd = false
          }
          if(res.body.data!=''){
            //去重处理
            var result = [],arr = [];
            var obj = {};
            arr = that.allData
            for(var i in res.body.data){
              arr.push(res.body.data[i])
            }
            for(var i =0; i < arr.length; i++){
              if(!obj[arr[i].id]){
                result.push(arr[i]);
                obj[arr[i].id] = true;
              }
            }
            that.allData = result
            //按品类分组
            var map = {},
            dest = [];
            for(var i = 0; i < result.length; i++){
              var ai = result[i];
              if(!map[ai.category_id]){
                dest.push({
                  category_id: ai.category_id,
                  category: ai.category,
                  unit:ai.unit,
                  data: [ai]
                });
                map[ai.category_id] = ai;
              }else{
                for(var j = 0; j < dest.length; j++){
                  var dj = dest[j];
                  if(dj.category_id == ai.category_id){
                    dj.data.push(ai);
                    break;
                  }
                }
              }
            }
            that.stockData.push.apply(that.stockData,dest)
          }
        }
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
        // var msg = 'a5551505160101010000000101d703000101dc'
        // that.$refs.mqttws.send(topic,msg)
        // that.$router.go(0)
        that.$message.info('页面已超时！')
        setTimeout(function(){
          that.backUp()
        },3000)
      } else {
        that.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    }
  },
  watch :{
    
  },
}
</script>

<style lang="less">
@keyframes fadeOutLeft{
  0%{opacity:1}
  100%{
    opacity:0;
    -webkit-transform:translate3d(-100%,0,0);
    transform:translate3d(-100%,0,0)
  }
}
.el-tooltip__popper{
  font-size: 0.3rem;
  padding: 0.2rem;
}
.wrcOutStockList{
  box-sizing: border-box;
  .tipDio{
    text-align: center;
    .el-dialog__header{
      padding: 0;
    }
    h2{
      font-size: 0.8rem;
      padding-bottom: 0.3rem;
    }
    .tips{
      font-size: 0.4rem;
      color: #F56C6C;
    }
  }
  .stockInfo{
    padding: 0.2rem;
    box-sizing: border-box;
    font-size: 0.4rem;
    line-height: 0.6rem;
    height: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item.flex{
      div{ margin-right: 5rem;}
    }
  }
  .table{
    .tab_tit{
      width: 100%;
      align-items: center;
      border-top: 0.02rem solid #ddd;
      border-bottom: 0.02rem solid #ddd;
      text-align: center;
      justify-content: space-between;
      .item{
        // width: 16.66%;
        font-size: 0.3rem;
        padding: 0.12rem 0;
        &:nth-child(1){
          width: 15%;
        }
        &:nth-child(2){
          width: 21%;
        }
        &:nth-child(3){
          width: 16%;
        }
        &:nth-child(4){
          width: 13%;
        }
        &:last-child{
          width: 35%;
        }
      }
    }
    .tabList{
      height: 6.6rem;
      overflow-y: auto;
      .item{
        .flex{
          width: 100%;
          align-items: center;
          text-align: center;
          padding: 0.2rem 0;
          border-bottom: 0.02rem solid #ddd;
          justify-content: space-between;
        }
        &.move{
          animation: fadeOutLeft 2s 1;
        }
        &.success{
          color: #67C23A
        }
        &.warning{
          color: #F56C6C
        }
        .itemLi{
          // width: 16.66%;
          padding: 0 0.2rem;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;
          font-size: 0.3rem;
          &:nth-child(1){
            width: 15%;
          }
          &:nth-child(2){
            width: 21%;
          }
          &:nth-child(3){
            width: 16%;
          }
          &:nth-child(4){
            width: 13%;
          }
          &:last-child{
            width: 35%;
          }
        }
      }
      .feifa{
        color: #F56C6C;
        .el-collapse-item__header{
           color: #F56C6C;
        }
      }
    }
    // .el-table{
    //   font-size: 0.3rem;
    //   td,th{
    //     padding: 0.12rem 0;
    //   }
    //   .cell{
    //     line-height: 1.5;
    //   }
    //   td,th.is-leaf{
    //     border-bottom: 0.03rem solid #EBEEF5;
    //   }
    //   .warning-row{
    //     color: #F56C6C;
    //   }
    //   .success-row{
    //     color: #67C23A;
    //   }
    // }
  }
  .configBtn{
    z-index: 99;
    padding: 0.3rem;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(0, 0, 0, .21);
    .tips{
      font-size: 0.4rem;
      color: #F56C6C;
    }
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
      &.is-disabled{
        background: #909399;
      }
    }
  }
  .el-collapse-item{
    .el-collapse-item__header{
      background: none;
      font-size: 0.3rem;
      height: 0.8rem;
      line-height: 0.8rem;
      color: #fff;
      padding: 0 1rem;
      position: relative;
      span{
        margin-right: 0.4rem;
      }
      &.is-active{
        border-bottom-color: #fff;
      }
    }
    .el-collapse-item__arrow{
      position: absolute;
      left: 0.2rem;
      top: 50%;
      margin-top: -0.15rem;
    }
    .el-collapse-item__wrap{
      background: none;
      border-bottom: none;
      .el-collapse-item__content{
        padding: 0;
        color: #67C23A;
      }
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/CUnmanned/wrcOutStock/wrcOutStockList.vue